import './SurveyItem.css'
import { useTranslation } from 'react-i18next';
import { format } from 'date-fns';
import { useEffect, useState } from 'react';

function convertDate(date) {
  if (!date) return '';
  return format(new Date(date), 'dd/MM/yyyy');
}

function MinSurveyItem({
  data,
  enterpriseName,
  bce,
  sector,
  selectHandler
}) {
  const { t } = useTranslation();

  const [windowWidth, setWindowWidth] = useState(
    typeof window !== 'undefined' ? window.innerWidth : 1200
  );

  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  function convertStatusText(statusTag) {
    if (statusTag === 'completed') return t('survey.list.completed');
    if (statusTag === 'not-started') return t('survey.list.not-started');
    if (statusTag === 'in-progress') return t('survey.list.started');
  }

  return (
    <div className="survey-item">
      <div className='enterprise__header'>
        <h3 className='enterprise__title'>
          <span className='enterprise-name__title'>{enterpriseName}</span>
          <span className='enterprise-info__title'>
            (N° BCE: {bce}) <strong>/</strong> {sector}
          </span>
        </h3>
      </div>

      <table className='mini-item__table'>
        <thead>
          {Array(windowWidth > 1200 ? 1 : data.length).fill().map((_, i) => (
            <tr key={i}>
              <th></th>
              <th>{t('survey.list.version')}</th>
              <th>{t('survey.list.updated')}</th>
              <th>{t('survey.list.status')}</th>
              <th></th>
            </tr>
          ))}
        </thead>

        <tbody>
          {data.map((item) => (
            <tr key={item._id}>
              <td>
                <input
                  type="radio"
                  name="survey-compare"
                  value={item._id}
                  onChange={() => selectHandler(item._id)}
                />
              </td>

              <td>
                {item.namespace
                  ? `${t('survey.list.questionnaire')} ${item.namespace}`
                  : t('survey.list.survey2020')}
              </td>

              <td>
                {convertDate(item.updatedAt || item.UpdatedAt)}
              </td>

              <td>
                <span className={`status-tag ${item.status}`}>
                  {convertStatusText(item.status)}
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default MinSurveyItem;